import { OfferModel } from '../../../../offer/model/OfferModel';
import { OfferAccordionCard } from '../../common/OfferCard/OfferAccordionCard';
import { RfqOfferAccordionContent } from '../../components/RfqOfferCard/components/RfqOfferAccordionContent';
import { RfqOfferActions } from '../../components/RfqOfferCard/components/RfqOfferActions';
import { RfqOfferCardContextProvider } from '../../components/RfqOfferCard/components/RfqOfferCardContextProvider';
import { RfqOfferSummary } from '../../components/RfqOfferCard/components/RfqOfferSummary';

interface RfqOfferCardProps {
    offer: OfferModel;
    expanded: boolean;
    onClick: () => void;
}

export const RfqOfferCard = (props: RfqOfferCardProps) => {
    return (
        <RfqOfferCardContextProvider offer={props.offer}>
            <OfferAccordionCard expanded={props.expanded} accordionContent={<RfqOfferAccordionContent />}>
                <RfqOfferSummary onClick={props.onClick} />
                <RfqOfferActions />
            </OfferAccordionCard>
        </RfqOfferCardContextProvider>
    );
};
